import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addCategory = ( category_name,item_type,sub_categories) => {
  return axios.post(API + "contracts/category/subcategory/manage/", {
    category_name,
    item_type,
    sub_categories,
  },{headers: authHeader(),});
};
const editCategory = ( category_id,category_name,item_type,sub_categories) => {
  return axios.post(API + "contracts/category/subcategory/manage/", {
    category_id,
    category_name,
    item_type,
    sub_categories,
  },{headers: authHeader(),});
};
const getCategory = (category_id)=>{
  return axios.get(API + "contracts/category/"+category_id+"/edit/",{headers: authHeader()} ) 
}

const viewListCategory = () =>{
  return axios.get(API + "contracts/categories/",{headers: authHeader()} ) 
}

const filtersubCategory = (selected_category) =>{
  return axios.get(API + `contracts/filter-subcategory/?category_name=${selected_category}`, {
    headers: authHeader(),
  });
}
const AddcategoryService = {
    addCategory,
    editCategory,
    getCategory,
    viewListCategory,
    filtersubCategory
  };
  export default AddcategoryService;